import React from "react";
import { useTracked } from "./state";
import * as jwtDecode from "jwt-decode";
import { IonLoading } from "@ionic/react";
import { useHistory } from "react-router";
import { useParams } from "react-router-dom";
import { loadAuthMode } from "./context/vault";
import { identityService } from "./services/vault";
import { AuthMode } from "@ionic-enterprise/identity-vault";
import { getUserIdentity } from "./api/identity";

const Auth: React.FC = () => {
  const history = useHistory();
  const params: any = useParams();
  const token = params["token"];
  const [state, dispatch] = useTracked();
  const [isLoading, setIsLoading] = React.useState(false);

  React.useEffect(() => {
    if (token) {
      processToken(token);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const processToken = async (token: string) => {
    try {
      setIsLoading(true);
      // const { sub, aud, keyid, iat } = jwtDecode(token);
      const { sub } = jwtDecode(token);
      if (sub) {
        await setSession({ identity: sub, token });
        if (state.identity) {
          await publishLogin(sub, token);
        }
        // history.replace('/page/issuers');
      }
      setIsLoading(false);
    } catch (error) {
      // console.log(error)
      setIsLoading(false);
      history.replace("/");
    }
  };

  const setSession = async (payload: any) => {
    const { identity, token } = payload;
    try {
      const w: any = await getUserIdentity(identity.toLowerCase());

      if (w && w?.wallet && w?.wallet?.identity) {
        await identityService.login(
          { username: identity, token, identity },
          AuthMode.SecureStorage
        );
        await setVaultAuth();

        dispatch({ wallet: w.wallet, type: "setWallet" });
        dispatch({ identity, type: "setIdentity" });
        dispatch({ aliases: w.wallet.aliases, type: "setAliases" });
        dispatch({ token, type: "setToken" });
      } else {
        dispatch({ type: "logout", appId: process.env.REACT_APP_APP_ID });
      }
    } catch (error) {
      // console.log(error);
      dispatch({ type: "logout", appId: process.env.REACT_APP_APP_ID });
    }
  };

  const setVaultAuth = async () => {
    const { authMode, biometricType, hasSession, biometricsSupported } =
      await loadAuthMode();

    dispatch({
      type: "setVaultAuth",
      authMode,
      biometricType,
      hasSession,
      biometricsSupported,
    });
  };

  const publishLogin = async (identity: string, token: string) => {
    if (state.mqm) {
      await state.mqm.pubnub.publish({
        channel: identity.toLowerCase(),
        meta: {
          type: "login",
        },
        message: { identity, token, appId: process.env.REACT_APP_APP_ID },
      });
    }
  };

  return (
    <React.Fragment>
      <IonLoading isOpen={isLoading} />
    </React.Fragment>
  );
};

export default Auth;
